module.exports = __webpack_public_path__ + "static/media/Pin.9c7ad0d7.png";